import { render } from "./OrderPage.vue?vue&type=template&id=1405a862&ts=true"
import script from "./OrderPage.vue?vue&type=script&lang=ts"
export * from "./OrderPage.vue?vue&type=script&lang=ts"

import "./OrderPage.vue?vue&type=style&index=0&id=1405a862&lang=scss"

import exportComponent from "/home/christmasatourhouse-com/www/tickets/releases/202610123691/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__